.group {
    width: 100%;
    border-radius: var(--mantine-radius-md);
    padding: var(--mantine-spacing-2xs);
}

.title {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.5px;
    padding: 0 var(--mantine-spacing-sm) var(--mantine-spacing-2xs);
}

.blue {
    background-color: var(--mantine-color-dibblue-0);
}
.blue .title {
    color: var(--mantine-color-dibblue-8);
}

.green {
    background-color: var(--mantine-color-sjøgrønn-1);
}
.green .title {
    color: var(--mantine-color-sjøgrønn-9);
}

.orange {
    background-color: var(--mantine-color-mars-0);
}
.orange .title {
    color: var(--mantine-color-mars-8);
}
